@if (!isLoading()) {
  <div class="door-codes">
    <tidy-text [helper]="'Door code'" />
    <div class="door-codes__value">
      @if (lockNames()) {
        {{ 'Smart lock connected:' | translate }} {{ lockNames() }}. {{ 'Each stay gets its own code, and guests see it in their guidebook.' | translate }}
      } @else {
        {{ 'No smart lock connected. Add the code you made for each stay, and guests see it in their guidebook.' | translate }}
      }
    </div>
    @if (firstLockId()) {
      <div class="door-codes__generate">
        <tidy-text
          [actionBody]="'Generate Access Code'"
          (action)="onGenerateCode()"
          class="link" />
        <tidy-text [smallHelper]="'A one-off code for the lock, not tied to a stay.'" />
      </div>
    }

    <div class="door-codes__stays">
      <tidy-text [smallHelper]="'Upcoming stays'" />
      @for (stay of stays(); track stay.reservation.id) {
        <div class="door-codes__stay">
          <span class="door-codes__stay-label">{{ stay.label }}</span>
          @if (stay.code) {
            <span class="door-codes__code">{{ stay.code }}</span>
          } @else {
            <span class="door-codes__none">{{ 'No code' | translate }}</span>
          }
          <tidy-text
            [actionBody]="stay.code ? 'Edit' : 'Add code'"
            (action)="openStay.emit(stay.reservation)"
            class="link" />
        </div>
      } @empty {
        <span class="door-codes__none">{{ 'No upcoming stays.' | translate }}</span>
      }
    </div>
  </div>
}
